export default __webpack_public_path__ + "static/media/gallery_00.8369148f.jpg";